import { render, staticRenderFns } from "./ConsorcioLmmSPObras.vue?vue&type=template&id=01714742&"
import script from "./ConsorcioLmmSPObras.vue?vue&type=script&lang=js&"
export * from "./ConsorcioLmmSPObras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports